import * as React from "react";
import { Search, RefreshCw } from "lucide-react";
import { cn } from "@/lib/utils";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

interface ToolbarProps {
  search?: {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
  };
  filters?: React.ReactNode;
  count?: React.ReactNode;
  onRefresh?: () => void;
  refreshing?: boolean;
  actions?: React.ReactNode;
  className?: string;
}

export function Toolbar({
  search,
  filters,
  count,
  onRefresh,
  refreshing,
  actions,
  className,
}: ToolbarProps) {
  return (
    <div className={cn("flex flex-wrap items-center gap-2", className)}>
      {search && (
        <div className="relative">
          <Search
            size={14}
            className="pointer-events-none absolute left-2.5 top-1/2 -translate-y-1/2 text-muted-foreground"
          />
          <Input
            value={search.value}
            onChange={(e) => search.onChange(e.target.value)}
            placeholder={search.placeholder ?? "Search..."}
            className="h-8 w-64 pl-8 text-[13px]"
          />
        </div>
      )}
      {filters}
      {count != null && (
        <span className="text-xs text-muted-foreground tabular-nums">
          {count}
        </span>
      )}
      <div className="flex-1" />
      {onRefresh && (
        <Button
          variant="ghost"
          size="icon"
          aria-label="Refresh"
          className="h-8 w-8"
          onClick={onRefresh}
        >
          <RefreshCw size={14} className={refreshing ? "animate-spin" : ""} />
        </Button>
      )}
      {actions}
    </div>
  );
}
